var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "383px",
    height: "382px",
    viewBox: "0 0 383 382",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "high_spec_icon")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "high_spec_icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.430568,349.674419 C302.430568,320.534884 286.583406,320.534884 286.583406,291.395349 C286.583406,262.255814 302.430568,262.255814 302.430568,233.116279 C302.430568,203.976744 286.583406,204.143256 286.583406,175.003721 C286.583406,145.864186 302.430568,145.864186 302.430568,116.724651 C302.430568,87.5851163 286.583406,87.5851163 286.583406,58.2790698 C286.583406,28.9730233 302.430568,29.1395349 302.430568,0 L366.152838,0 L366.152838,349.674419 L302.430568,349.674419 Z",
    id: "Path",
    stroke: "#020202",
    strokeWidth: 31.8333333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 349.674419,
    x2: 382,
    y2: 349.674419,
    id: "Path",
    stroke: "#020202",
    strokeWidth: 31.8333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6960699,124.883721 C42.670436,133.818236 47.7141813,145.950259 47.7141813,158.602326 C47.7141813,171.254392 42.670436,183.386416 33.6960699,192.32093",
    id: "Path",
    stroke: "#020202",
    strokeWidth: 31.8333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9126638,69.1023256 C140.631812,118.77407 140.631812,199.263139 90.9126638,248.934884",
    id: "Path",
    stroke: "#020202",
    strokeWidth: 31.8333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.294323,12.8213953 C185.155905,51.552131 206.993243,104.118797 206.993243,158.935349 C206.993243,213.751901 185.155905,266.318567 146.294323,305.049302",
    id: "Path",
    stroke: "#020202",
    strokeWidth: 31.8333333
  }))))));
};
export default __webpack_public_path__ + "static/media/high_spec_icon.b0338b1e.svg";
export { SvgComponent as ReactComponent };